import styled from 'styled-components';

export const FlexAnchor = styled.a`
  display: flex;
`;

export const RelativeDiv = styled.div`
  position: relative;
`;
export const CartImg = styled.img`
  width: 48px;
  height: 48px;
  @media (max-width: 720px) {
    display: none;
  }
`;
export const CartImgMobile = styled.img`
  display: none;
  @media (max-width: 720px) {
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 6px;
    margin-top: 3px;
  }
`;
export const ProfileImgMobile = styled.img`
  display: none;
  @media (max-width: 720px) {
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 6px;
    margin-top: 3px;
  }
`;
export const ProfileImgMobileOuter = styled.div`
  display: none;
  @media (max-width: 720px) {
    display: block;
    position: relative;
    margin: 0 20px 0px 10px;
  }
`;
export const Header = styled.header`
  width: 100%;
  background-color: #fff;
  border-bottom: ${(props) =>
    props.main ? '1px solid rgba(238, 238, 238, 0.77)' : 'none'};
  height: ${(props) => (props.main ? '64px' : '85px')};
  line-height: ${(props) => (props.main ? '54px' : '70px')};
  position: ${(props) => (props.pageType ? 'sticky' : 'fixed')};
  top: ${(props) =>
    props.main
      ? props.location == 'PDP'
        ? props.top
        : '68px'
      : props.location == 'PDP'
        ? props.top
        : '0'};
  z-index: ${(props) => (props.zIndex ? props.zIndex : '9')};
  transition: top 0.8s ease-in-out;
  @media (min-width: 768px) {
    position: fixed;
  }
  @media (max-width: 720px) {
    display: ${(props) => props.display};
    top: ${(props) =>
      props.location == 'PDP' ? `${props.showHeader}` : props.top || '0'};
    height: ${(props) => (props.main ? '50px' : '56px')};
    line-height: ${(props) => (props.main ? '50px' : '56px')};
    border-bottom: 1px solid #0000000d;
  }
`;

export const HeaderCentered = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 75px;
  padding: 0 6%;
  @media (max-width: 720px) {
    max-width: 100%;
    padding: 0 14px;
    justify-content: flex-start;
    height: 100%;
    border-bottom: none;
  }
  .reviewHeading {
    display: flex;
    align-items: center;
    p {
      font-size: 15px;
      font-weight: 500;
      margin-left: 10px;
    }
    @media (min-width: 768px) {
      display: none;
    }
  }
`;
export const DesktopLeftSection = styled.div`
  display: flex;
  flex-basis: 90%;
  @media (max-width: 720px) {
    flex-basis: 35%;
  }
  justify-content: center;
  gap: 15%;
`;
export const CartandProfileSec = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  @media (max-width: 720px) {
    order: 2;
    flex-basis: ${(props) => (props.showShopCta ? '25%' : '22%')};
  }
`;

export const CartIcon = styled.div`
  cursor: pointer;
  margin-left: 16px;
  height: 100%;
  line-height: 1;
  position: relative;
  @media (min-width: 720px) {
    margin-right: 24px;
  }

  span {
    position: absolute;
    bottom: 14px;
    color: #ffffff;
    font-size: 10px;
    font-weight: 500;
    right: 0;
    display: inline-block;
    left: 15px;
    @media (min-width: 768px) {
      left: 32px;
    }
    top: -10px;
    width: 16px;
    text-align: center;
    background: #ef4e5e;
    border-radius: 50%;
    height: 16px;
    line-height: 16px;
    &.bounce {
      animation: wiggle 1s ease-in-out;
      transition: all 1s ease-in-out;

      @keyframes wiggle {
        10% {
          transform: translateY(0);
        }
        25% {
          transform: translateY(-5px);
        }
        50% {
          transform: translateY(0);
        }
        75% {
          transform: translateY(-5px);
        }
        100% {
          transform: translateY(0);
        }
      }
    }
  }

  p {
    font-size: 16px;
    color: #1a1a1a;

    @media (max-width: 720px) {
      display: none;
    }
  }
`;

export const LeftSecMobile = styled.div`
  @media (min-width: 720px) {
    position: absolute;
    right: 4%;
  }
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const HemburgerIcon = styled.div`
  margin-right: 16px;
  display: ${(props) => (props.hideHamIcon ? 'none' : 'flex')};

  @media (min-width: 768px) {
    cursor: pointer;
    position: absolute;
    left: 4%;
  }
`;
export const BackButton = styled.div`
  display: none;
  background-image: url('https://images.myloapp.in/NestJsUploads/1668754439814-BackArrow.webp');
  width: 24px;
  height: 24px;
  opacity: 0.8;
  background-size: 24px;
  @media (max-width: 720px) {
    margin-right: 16px;
    display: ${(props) => (props.hideHamIcon ? 'flex' : 'none')};
  }
`;
export const OrderSuccessfulText = styled.span`
  font-size: 16px;
  opacity: 0.87;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 12px;
`;
export const CoinsHistoryTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: hsl(0deg 0% 0% / 43%);
  display: ${(props) => (props.hideHamIcon ? 'block' : 'none')};
`;

export const MyloLogo = styled.div`
  display: ${(props) =>
    props.coinsPage && props.hideHamIcon ? 'none' : 'flex'};
  img {
    width: 44%;
  }
  @media (min-width: 720px) {
    align-items: center;
    cursor: pointer;

    img {
      width: 60%;
    }
  }

  svg {
    width: 120px;
    height: auto;

    @media (max-width: 720px) {
      width: 88px;
      height: 30px;
      position: relative;
      bottom: 2px;
    }
  }
`;
export const DeviceStyleDesktop = styled.div`
  display: block;
  @media (max-width: 720px) {
    display: none;
  }
`;
export const DeviceStyleMobile = styled.div`
  display: none;
  @media (max-width: 720px) {
    display: block;
  }
`;
export const TypicalMobileStyle = styled.div`
  display: none;
  @media (max-width: 720px) {
    display: block;
    margin-top: 100px;
    padding: 0 8px 8px;
  }
  .typicalStyleMobile {
    width: 100%;
    border: solid 1px #bababa;
    height: 32px;
    padding: 20px 12px 20px 20px;
    transition: border 0.3s ease;
    font-family: Montserrat;
    border-radius: 12px;
    cursor: pointer;
    color: #bababa;
    // margin-top: 12px;
    p {
      line-height: 0;
      font-size: 16px;
    }
  }
`;

export const SearchSection = styled.div`
  width: 100%;
  max-width: ${(props) => (props.newUX ? '56%' : '60%')};
  position: relative;
  // margin-left: auto;
  // margin-right: 46px;
  z-index: 998;
  // @media (max-width: 720px) {
  //     display: ${(props) => (props.SearchClass ? 'block' : 'none')};
  // }
  @media (max-width: 720px) {
    margin-top: ${(props) => (props.isForJoyfulPage ? '2px' : '')};
  }

  svg {
    @media (max-width: 720px) {
      position: absolute;
      left: 17px;
      top: 23px;
      width: 14px;
      height: 14px;
    }
  }

  .iconSectionFocus {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    background: rgb(239, 78, 94);
    height: 100%;
    border-radius: 0 20px 20px 0;
    width: 60px;

    svg {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 10px;
      right: 22px;
    }
  }

  .iconSection {
    svg {
      width: 16px;
      opacity: 0.5;
      height: 16px;
      position: absolute;
      top: 14px;
      right: 22px;
    }
  }

  .typicalStyle {
    width: 100%;
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: ${(props) => (props.newUX ? '#eee' : ' #f5f5f6')};
    height: 32px;
    padding: 20px 12px 20px 20px;
    outline: none;
    transition: border 0.3s ease;
    font-family: Montserrat;
    border-radius: 20px;
    cursor: pointer;

    p {
      line-height: 0;
      font-size: 16px;
    }

    @media (max-width: 720px) {
      padding-left: ${(props) => (props.isForJoyfulPage ? '40px' : '0px')};
    }
  }

  input {
    width: 100%;
    border-radius: 20px;
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: #f5f5f6;
    height: 32px;
    padding: 20px 12px 20px 34px;
    outline: none;
    transition: border 0.3s ease;
    font-family: Montserrat;
    @media (max-width: 720px) {
      height: 40px;
      border-radius: 4px;
    }

    &:focus {
      border: solid 1px #384140;
      border-radius: 4px;
      @media (min-width: 720px) {
        border: solid 1px rgba(0, 0, 0, 0.28);
        border-radius: 20px;
        background: #fff;
        caret-color: rgb(239, 78, 94);
        svg {
          top: 30%;
          left: 35%;
          position: absolute;
        }
      }

      @media (max-width: 720px) {
        border-radius: ${(props) => (props.isForJoyfulPage ? '10px' : '')};
      }
    }

    &::placeholder {
      color: hsl(0deg, 0%, 0%, 60%);
      font-size: 13px;
      opacity: 0.5;
      font-weight: 500;
    }
  }

  button {
    border: none;
    outline: none;
    background: #63b0a8;
    width: 40px;
    height: 36px;
    border-radius: 0 6px 6px 0;
    position: absolute;
    right: 0;
    top: 19px;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 720px) {
    max-width: 100%;
    position: ${(props) => (props.isForJoyfulPage ? 'sticky' : 'absolute')};
    top: ${(props) => (props.showNewHeader ? '144px' : '64px')};
    left: 0;
    padding: 0 4px;
    background: #fff;
    padding-bottom: ${(props) => (props.isForJoyfulPage ? '5px' : '')};
  }

  .search_back {
    opacity: 0.8;
  }
`;

export const SearchBackContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileSearchOverlay = styled.div`
  width: 100%;
  @media (max-width: 720px) {
    height: 100vh;
    width: 100vw;
    background: rgb(0 0 0 / 18%);
    position: absolute;
    top: 43px;
    left: 0;
    z-index: 99;
  }
`;

export const MobileSearch = styled.div`
  display: none;

  @media (max-width: 720px) {
    display: block;
    margin-top: 8px;
    display: block;
  }

  img {
    width: 100%;
    height: auto;
    position: relative;
    top: 2px;
    opacity: 0.9;
  }
`;

export const LoginSection = styled.div`
  margin: ${(props) => (!props.showLogout ? '0 0 10px' : '0px 12px 24px')};
  height: 64px;
  background: hsl(180deg 4% 90% / 24%);
  cursor: pointer;
  @media (min-width: 720px) {
  }
  &.desktopLogin {
    background: none;
    height: auto;
    margin: 0;
  }
  .accountIcon {
    width: 40px !important;
    height: 40px !important;

    border-radius: 0 !important;
  }
  .low {
    opacity: 0.4;
  }
  span {
    @media (min-width: 720px) {
      position: relative;
      top: 2;
    }
  }

  .logoutText {
    margin-left: 5px;
    font-size: 14px;
  }
  .logout {
    font-size: 12px;
    font-weight: 500;
    display: flex;
    color: hsl(0deg, 0%, 0%, 80%);
    line-height: 1;
    align-items: center;

    p {
      font-weight: 500 !important;
      color: rgb(0 0 0 / 80%);
      font-size: 14px;
    }

    & > div {
      width: 100%;
    }
    .desktopSideDrawerLogout {
      flex-direction: row;
      column-gap: 8px;
      font-size: 15px;
    }
  }
  .desktopLoginButton {
    font-size: 12px;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    column-gap: 20px;
    padding: 0 16px;
    color: hsl(0deg, 0%, 0%, 87%);
    height: 100%;
    align-items: center;
    @media (min-width: 768px) {
      margin-left: 29px;
    }
    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      position: relative;
      bottom: 1px;
    }

    & > div {
      width: 100%;
    }
  }
  .loginButton {
    font-size: 12px;
    font-weight: 500;
    display: flex;
    gap: 10px;
    color: hsl(0deg, 0%, 0%, 87%);
    height: 100%;
    align-items: center;
    line-height: 1;

    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      position: relative;
      bottom: 1px;
    }

    & > div {
      width: 100%;
    }
  }

  .collapsible {
    padding: 0 20px 0 45px;
    display: flex;
    align-items: center;
    margin: 8px 0;
  }
  .iconsText {
    font-size: 16px;
    text-align: center;
    color: #1a1a1a;
  }
`;

export const WelcomeText = styled.p`
  padding-bottom: ${(props) => (props.logout ? '0' : '4px')};
  padding-top: ${(props) => (props.logout ? '6px' : '0')};
  opacity: 0.3;
  font-size: ${(props) => (props.logout ? '12px' : '10px')};
  color: #040404;
  margin-bottom: 4px;
`;

export const LoginLogut = styled.p`
  font-weight: 600;
`;

export const CrosstoClosedrawer = styled.span`
  margin-right: 16px;
  font-size: 40px;
  font-weight: 400;
  position: relative;
  display: inline-block;
  top: -2px;
  color: hsl(0deg 0% 0% / 60%);
`;

export const TrackOrderDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 24px;

  p {
    color: hsl(0deg, 0%, 0%, 80%);
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    height: 14px;
    position: relative;
    top: 2px;
  }

  @media (max-width: 720px) {
    display: none;
  }
`;
export const Cross = styled.div`
  position: absolute;
  top: 1px;
  font-size: 33px;
  right: 17px;
  color: #a5a3a3;
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: default;
  }
`;

export const HeaderMainOption = styled.div`
  margin-left: auto;
  @media (max-width: 720px) {
    display: none;
  }
`;

export const NavBarUl = styled.div`
  max-width: 1260px;
  height: 52px;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 720px) {
    display: none;
  }

  & .dropdown {
    font-size: 12px;
    font-weight: 500;
    margin: 0 18px;
    position: relative;
    display: flex;
    align-items: center;
    height: 32px;
    color: #040404;
    transition: all 0.3s ease;

    &:hover {
      color: #ef4e5e;
      text-decoration: none;
      text-underline-offset: 9px;
      transform: translateY(0);
      text-decoration-thickness: 4px;
    }

    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  & .dropdown_content {
    display: none;
    position: absolute;
    min-width: 224px;
    left: 0;
    top: 32px;
    background-color: #fff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    z-index: 1;
    line-height: 4;
    padding: 6px 0px;
  }

  .listName {
    text-decoration: none;
    color: #474747;
    display: block;
    line-height: 34px;
    padding: 0 16px 0 0;
    text-transform: capitalize;

    & .active {
      color: #ef4e5e;
    }

    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  .dropdown_content .exploreList {
    display: flex;
    justify-content: space-between;

    .ltwolthree {
      // padding: 0 16px 0 22px;
      position: relative;
      color: hsl(0deg, 0%, 0%, 87%);
      line-height: 34px;
      text-transform: capitalize;
      font-size: 13px;
    }

    .noBorder {
      border: none;
    }
  }

  .horiz {
    display: flex;
    flex-direction: column;
  }

  .rightArrow {
    order: 0 !important;
    margin-left: 5px;
  }

  .line {
    display: flex;
    justify-content: space-between;

    &:hover {
      background-color: #f1f1f1;
    }
  }

  .level_not_1 {
    left: 100%;
    top: 0;
  }

  & .dropdown:hover .dropdown_content {
    display: block;
  }

  & .dropdown:hover .level_not_1 {
    display: none;
  }

  & .show0:hover .showHead1 {
    display: block;
  }

  & .show1:hover .showHead2 {
    display: block;
  }

  & .show0,
  .show1 {
    position: relative;
    padding-left: 10px;
  }

  & .active {
    color: #ef4e5e;
  }

  .nomargin {
    margin: 0px;
  }
`;

export const Option = styled.li`
  column-gap: 4px;
  margin: 0 18px 0 0 !important;
  .downArrow {
    width: 15px;
    height: 15px;
    transform: rotate(90deg);
    order: 1 !important;
  }
  &.dropdownParent {
    display: flex;
    align-items: center;
  }
`;

export const HeaderImages = styled.div`
  background-image: ${(props) => `url(${props.bg})`};
  width: ${(props) => props.imgWidth}px;
  height: ${(props) => props.imgHeight}px;
  margin-right: 6px;
`;

export const ArcSection = styled.span`
  display: none;
  @media (min-width: 720px) {
    border: 1px solid #dadada; /* the 'strokes' of the arc */
    display: inline-block;
    min-width: 125px; /* the width of the innermost element */
    justify-content: center;
    min-height: 225px; /* the height of the innermost element */
    display: flex;
    left: 44%;
    top: -117%;
    position: absolute;
    padding: 0.5em; /* the spacing between each arc */
    border-radius: 50%; /* for making the elements 'round' */
    border-top-color: transparent; /* hiding the top border */
    border-bottom-color: transparent;
    border-left: transparent;
    transform: rotate(90deg);
    /* border-top: 0px; */
    background-color: #fff;

    a {
      transform: rotate(-90deg);
      padding-top: 30px;
    }
    img {
      width: 85px;
    }
  }
`;
export const TrackDesktopNew = styled.div`
  position: relative;
  line-height: 1;
  margin-right: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 720px) {
    display: none;
  }
`;
